import * as React from "react"

const CloseIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g
      stroke="#433F4E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      clipPath="url(#a)"
    >
      <path d="m17.998 6-12 12M5.998 6l12 12" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M-.002 0h24v24h-24z" />
      </clipPath>
    </defs>
  </svg>
)
export default CloseIcon
